var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronTriangleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.801 6.501a.226.226 0 0 0-.069.176c0 .104.057.165 1.806 1.916.993.995 1.841 1.828 1.883 1.85.042.022.105.04.141.04.048 0 .548-.483 1.914-1.848 1.017-1.017 1.857-1.872 1.866-1.901.024-.076-.009-.18-.079-.245-.062-.057-.085-.057-3.727-.057H4.871l-.07.069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronTriangleDown);
export default __webpack_public_path__ + "static/media/chevronTriangleDown.5de17ce2f7dd0a77575a89797c7bfd32.svg";
export { ForwardRef as ReactComponent };